import { API } from "../../backend";

export const CreateOpportunity = async (user) => {
  return fetch(`${API}/opportunity/create`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getAllOpportunities = (page, limit, approved) => {
  return fetch(
    `${API}/opportunity/get/?page=${page}&&limit=${limit}&&approved=${approved}`,
    {
      method: "GET",
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getRandomOpportunity = () => {
  return fetch(`${API}/opportunity/getRandom`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const applyOpportunity = async (user, id) => {
  return fetch(`${API}/opportunity/apply/${id}`, {
    method: "PUT",

    body: user,
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
